import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchRevenueDynamicsIndicators (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/connectors/revenue/dynamics/indicators`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, { cancelToken: source.token }).then(response => response.data)
}

function fetchRevenueDynamics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/connectors/revenue/dynamics`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, { cancelToken: source.token }).then(response => response.data)
}

export default {
  fetchRevenueDynamics,
  fetchRevenueDynamicsIndicators,
}
